'use client'

import dynamic from 'next/dynamic'
import { useTheme } from '@/contexts/ThemeContext'

// 클라이언트 사이드에서만 렌더링되도록 동적 임포트
const LoginForm = dynamic(() => import('@/components/LoginForm'), {
  ssr: false,
  loading: () => <LoginPageLoading />
})

function LoginPageLoading() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen flex items-center justify-center px-4 xxs:px-2 ${
      theme === 'light'
        ? 'bg-[#f4f7fb]'
        : 'bg-[#0f172a]'
    }`}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 xxs:h-10 w-12 xxs:w-10 border-b-2 border-[#2b6df0] mx-auto"></div>
        <p className={`mt-4 xxs:mt-3 xxs:text-sm ${
          theme === 'light' ? 'text-gray-600' : 'text-gray-400'
        }`}>로딩중...</p>
      </div>
    </div>
  )
}

export default function LoginPage() {
  return <LoginForm />
}
